import { service } from '../../../service';

const state = {
  loading: false,
  items: [],
  paginatedItems: {
    candidate: {
      docs: [],
      totalDocs: 0,
      offset: 0,
      limit: 30,
      totalPages: 1,
      page: 1,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
  },
};

const actions = {
  async fetch({ commit, rootState }, search) {
    commit('setLoading', true);

    var url = `/candidates/${rootState.account.company._id}/${rootState.account.location._id}`;
    url = url.params(search);

    return service.get(url).then((result) => {
      commit('setItems', result.candidates);
      return;
    });
  },

  async search({ commit, rootState }, search) {
    var url = `/candidates/${rootState.account.company._id}/${rootState.account.location._id}`;
    url = url.params(search);

    return service.get(url).then((result) => {
      return result.candidates;
    });
  },

  async fetchAll({ commit, rootState }, payload) {
    commit('setLoading', true);

    return service
      .get(
        `/candidates/${rootState.account.company._id}/${rootState.account.location._id}/all`
      )
      .then((result) => {
        return result.candidates;
      });
  },

  async fetchById({ commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .get(
        `/candidates/${rootState.account.company._id}/${rootState.account.location._id}/${id}`
      )
      .then((result) => {
        commit('setLoading', false);
        return result;
      });
  },

  async create({ dispatch, commit, rootState }, payload) {
    if (payload.documents && payload.documents.length > 0) {
      const newDocuments = await dispatch(
        'documents/uploadFiles',
        { documents: payload.documents, folder: 'candidates' },
        { root: true }
      );
      console.log(newDocuments);
      if (newDocuments) {
        payload.documents = newDocuments;
      }
    }

    var result = await service.post(
      `/candidates/${rootState.account.company._id}/${rootState.account.location._id}`,
      payload
    );
    if (result) {
      commit('newItem', result.candidate);
      dispatch('alert/success', result.message, { root: true });

      var log = {
        user: rootState.account.user_id,
        userName: rootState.account.user.name,
        action: 'create',
        object: 'candidate',
        objectId: result.candidate._id,
        caption: `Created new candidate: ${result.candidate.name}`,
      };
      dispatch('logs/createLog', log, { root: true });
      return result.candidate;
    }
  },

  async createBulk({ dispatch, commit, rootState }, payload) {
    var result = await service.post(
      `/candidates/${rootState.account.company._id}/${rootState.account.location._id}/bulk`,
      payload
    );
    if (result) {
      commit('newItems', result.candidates);
      dispatch('alert/success', result.message, { root: true });
      return;
    }
  },

  async update({ dispatch, commit, rootState }, payload) {
    var payload = { ...payload };
    var documents = payload.documents.filter((doc) => {
      return !doc.filename;
    });
    var existingDocuments = payload.documents.filter((doc) => {
      return doc.filename;
    });

    payload.documents = existingDocuments;
    if (documents.length > 0) {
      const newDocuments = await dispatch(
        'documents/uploadFiles',
        { documents: documents, folder: 'candidates' },
        { root: true }
      );
      if (newDocuments) {
        payload.documents = [...existingDocuments, ...newDocuments];
      }
    }

    var result = await service.patch(
      `/candidates/${rootState.account.company._id}/${payload._id}`,
      payload
    );
    if (result) {
      commit('updateItem', result.candidate);
      dispatch('alert/success', result.message, { root: true });

      var log = {
        user: rootState.account.user_id,
        userName: rootState.account.user.name,
        action: 'update',
        object: 'candidate',
        objectId: result.candidate._id,
        caption: `Updated candidate: ${payload.name}`,
      };
      dispatch('logs/createLog', log, { root: true });
      return result.candidate;
    }
  },

  async delete({ dispatch, commit, rootState }, payload) {
    return service
      .delete(`/candidates/${rootState.account.company._id}/${payload._id}`)
      .then((result) => {
        commit('deleteItem', result.id);
        dispatch('alert/success', result.message, { root: true });

        var log = {
          user: rootState.account.user_id,
          userName: rootState.account.user.name,
          action: 'delete',
          object: 'candidate',
          caption: `Deleted candidate: ${payload.name}`,
        };
        dispatch('logs/createLog', log, { root: true });
        return;
      });
  },

  async transfer({ dispatch, commit, rootState }, payload) {
    return service
      .patch(
        `/transfer/${rootState.account.company._id}/${payload.location}/${payload.candidate}/candidate`
      )
      .then((result) => {
        commit('deleteItem', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async fetchAllCandidatePaginated({ commit, rootState }, data) {
    commit('setLoading', true);

    var url = `/candidates/company/${rootState.account.company._id}/location/${rootState.account.location._id}`;
    url = url.params(data);
    return service.get(url).then((result) => {
      commit('setPaginatedItems', result);
    });
  },
};

const mutations = {
  setPaginatedItems(state, jobs) {
    state.paginatedItems = jobs;
    state.loading = false;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setItems(state, items) {
    state.items = items;
    state.loading = false;
  },
  newItem(state, item) {
    state.items.push(item);
    state.loading = false;
  },
  newItems(state, items) {
    state.items = state.items.concat(items);
    state.loading = false;
  },
  updateItem(state, item) {
    var index = state.items.findIndex((i) => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.items.splice(index, 1, item);
    }
    state.loading = false;
  },
  deleteItem(state, id) {
    var index = state.items.findIndex((item) => {
      return item._id === id;
    });
    if (index !== -1) {
      state.items.splice(index, 1);
    }
    state.loading = false;
  },
};

export const candidates = {
  namespaced: true,
  state,
  actions,
  mutations,
};
